import axios from './axiosInstance';

export function postUser(data) {
    return axios.post('/admin/register', data);
}